(()=>{
  const observed=new WeakSet();
  let queued=false;

  const isElement=value=>value&&value.nodeType===1;
  const nonTextControlSelector='button,[role="button"],input,select,textarea';
  const textOf=el=>(el?.textContent||'').trim().replace(/\s+/g,' ');
  const metaOf=el=>`${textOf(el)} ${el?.getAttribute?.('aria-label')||''} ${el?.getAttribute?.('title')||''}`.toLowerCase();
  const isAddToCart=el=>isElement(el)&&el.matches?.('button,a,[role="button"],input[type="button"],input[type="submit"]')&&/add\s+to\s+cart/i.test(metaOf(el));

  const descriptor=el=>{
    if(!isElement(el))return '';
    const attrs=[...el.attributes].map(attr=>`${attr.name}=${attr.value}`).join(' ');
    return `${el.tagName} ${el.id||''} ${el.className||''} ${attrs}`.toLowerCase();
  };

  const isEaHost=el=>isElement(el)&&/(?:ea|essential|essent|sticky).*(?:cart|offer|upsell|product)|(?:cart|offer|upsell|product).*(?:ea|essential|essent|sticky)/i.test(descriptor(el));

  const directText=el=>[...el.childNodes]
    .filter(node=>node.nodeType===3)
    .map(node=>node.textContent||'')
    .join(' ')
    .trim()
    .replace(/\s+/g,' ');

  const findProductStrip=(cta,root)=>{
    let node=cta.parentElement;
    for(let depth=0;node&&depth<8;depth+=1,node=node.parentElement){
      const text=textOf(node);
      if(node.querySelector?.('img')&&/\$\s*\d/.test(text)&&text.length<1400)return node;
      if(node===root)break;
    }
    return null;
  };

  const isTopOfferStrip=strip=>{
    const rect=strip?.getBoundingClientRect?.();
    if(!rect)return false;
    const topLimit=Math.min(260,Math.max(180,window.innerHeight*.28));
    return rect.width>=180&&rect.height>=34&&rect.height<=180&&rect.bottom>0&&rect.top<=topLimit;
  };

  const paintProductText=(strip,cta)=>{
    if(!isElement(strip)||!isTopOfferStrip(strip)||!isElement(cta))return;

    strip.querySelectorAll('*').forEach(el=>{
      /* Preserve the native Add to cart control and every other button/control exactly as EA renders it. */
      if(el===cta||cta.contains(el))return;
      if(el.closest?.(nonTextControlSelector))return;
      if(el.matches?.('img,svg,path,line,polyline,polygon,use'))return;

      const own=directText(el);
      if(!own||/add\s+to\s+cart/i.test(own))return;
      if(/^[‹›«»←→<>]+$/.test(own))return;

      /* Product title links are intentionally included here; only their text color is changed. */
      el.style.setProperty('color','#000','important');
      el.style.setProperty('-webkit-text-fill-color','#000','important');
    });
  };

  const scanOfferRoot=root=>{
    if(!root?.querySelectorAll)return;
    [...root.querySelectorAll('button,a,[role="button"],input[type="button"],input[type="submit"]')]
      .filter(isAddToCart)
      .forEach(cta=>{
        const strip=findProductStrip(cta,root);
        if(strip)paintProductText(strip,cta);
      });
  };

  const looksLikeEaOfferRoot=(root,host)=>{
    if(isEaHost(host))return true;
    const text=textOf(root);
    return !!root?.querySelector?.('img')&&/add\s+to\s+cart/i.test(text)&&/\$\s*\d/.test(text)&&text.length<5000;
  };

  const scan=(scope=document)=>{
    scope.querySelectorAll?.('*').forEach(host=>{
      if(!host.shadowRoot||!looksLikeEaOfferRoot(host.shadowRoot,host))return;
      observe(host.shadowRoot);
      scanOfferRoot(host.shadowRoot);
    });

    if(scope!==document&&scope?.host&&looksLikeEaOfferRoot(scope,scope.host))scanOfferRoot(scope);
  };

  const observe=root=>{
    if(!root||observed.has(root)||!('MutationObserver' in window))return;
    observed.add(root);
    new MutationObserver(schedule).observe(root,{
      childList:true,
      subtree:true,
      characterData:true,
      attributes:true,
      attributeFilter:['class','aria-hidden','aria-expanded','open','data-state']
    });
  };

  const schedule=()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{
      queued=false;
      scan(document);
      setTimeout(()=>scan(document),120);
    });
  };

  const start=()=>{
    observe(document.documentElement);
    scan(document);
    setTimeout(()=>scan(document),250);
    setTimeout(()=>scan(document),800);
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();

  window.addEventListener('load',()=>setTimeout(()=>scan(document),400),{once:true});
  document.addEventListener('shopify:section:load',()=>setTimeout(()=>scan(document),80));
})();
